export default __webpack_public_path__ + "static/media/gallery_00.417751c7.jpg";